// Функции для работы с избранным
export const toggleFavorite = (rack, favorites, setFavorites) => {
  setFavorites(prev => {
    const isAlreadyFavorite = prev.some(item => item.id === rack.id);
    if (isAlreadyFavorite) {
      return prev.filter(item => item.id !== rack.id);
    } else {
      return [...prev, rack];
    }
  });
};

export const isFavorite = (rackId, favorites) => {
  return favorites.some(item => item.id === rackId);
};